import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MairaCallConfirm from '../../components/modal/MairaCallConfirm';
import { triggerMairaCall } from '../../actions/records';

class MairaCallConfirmDialog extends Component {
  render() {
    return (
      <div>
        <MairaCallConfirm {...this.props} />
      </div>
    );
  }
}

MairaCallConfirmDialog.propTypes = {
  triggerMairaCall: PropTypes.func.isRequired,
};

export default connect(null, {
  triggerMairaCall,
})(MairaCallConfirmDialog);
